import React, { useState } from "react";

//Third Party
import { useTable, useSortBy, useFilters } from "react-table";
import { useExportData } from "react-table-plugins";
import "jspdf-autotable";
//Styles
import "../../../../_metronic/assets/sass/components/CustomTable.scss";
import { KTIcon } from "../../../../_metronic/helpers";
import { CustomPagination, SquireIconWrapper } from "../lib";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { updateWomenFanCard } from "../../../api/womenFanCard/womenFanCardApi";
import { toast } from "react-toastify";
import { Button, Form, Modal } from "react-bootstrap";
interface ProfilesListTableProps {
  data: any; // Replace 'any' with the appropriate type for your data
  queryString: any;
  setQueryString: any;
  refetch: () => void;
  numberInPage: number | string;
}

const WomenListTable = ({
  data,
  queryString,
  setQueryString,
  refetch,
  numberInPage,
}: ProfilesListTableProps) => {
  // Define a default UI for filtering
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const updateFanCardStatus = useMutation({
    mutationFn: async ({ id, body }: { id: string; body: any }) => {
      return await updateWomenFanCard(id, body);
    },
    onSuccess: () => {
      refetch();
      toast.success("بروزرسانی با موفقیت انجام شد");
    },
  });

  function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length;

    return (
      <input
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`Search ${count} records...`}
      />
    );
  }

  const handleReject = (id) => {
    setSelectedId(id);
    setShowRejectModal(true);
  };

  const confirmReject = () => {
    updateFanCardStatus.mutate({
      id: selectedId,
      body: { status: "rejected", rejectReason: rejectReason },
    });
    setShowRejectModal(false);
    setRejectReason("");
  };

  const defaultColumn = {
    Filter: DefaultColumnFilter,
  };

  const showStatus = (statusType: string) => {
    if (statusType == "pending") {
      return "در حال بررسی";
    }
    if (statusType == "accepted") {
      return "تایید شده";
    }
    if (statusType == "received") {
      return "دریافت شده است";
    }
    if (statusType == "shipping") {
      return "کارت در حال ارسال است";
    }
    if (statusType == "rejected") {
      return "رد شده";
    }

    return "نامشخص";
  };

  let columns = React.useMemo(
    () => [
      {
        Header: <HeaderTextIcon text={"ردیف"} />,
        accessor: "id",
        Cell: ({ value }) => {
          return <span className={"rowNum"}>{value}</span>;
        },
      },

      {
        Header: <HeaderTextIcon text={"نام و نام خانوادگی"} />,
        accessor: (row) => `${row.firstName} ${row.lastName}`,
        id: "fullName",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: <HeaderTextIcon text={"کد ملی"} />,
        accessor: "nationalCode",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: <HeaderTextIcon text={"وضعیت درخواست"} />,
        accessor: "status",
        Cell: ({ value }) => <span>{showStatus(value)}</span>,
      },
      {
        Header: <HeaderTextIcon text={"کارت ملی"} />,
        accessor: "nationalCardImage",
        Cell: ({ value }) => {
          if (value?.path) {
            return (
              <a href={`${process.env.REACT_APP_BASE_URL}${value?.path}`}>
                تصویر کارت ملی
              </a>
            );
          }
          return "-";
        },
      },
      {
        Header: <HeaderTextIcon text={"تعداد درخواست ها"} />,
        accessor: "tries",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: <HeaderTextIcon text={"عکس پرسنلی"} />,
        accessor: "personalImage",
        Cell: ({ value }) => {
          if (value?.path) {
            return (
              <a href={`${process.env.REACT_APP_BASE_URL}${value?.path}`}>
                تصویر پرسنلی
              </a>
            );
          }
          return "-";
        },
      },

      {
        Header: <HeaderTextIcon text={"تایید / رد"} />,
        accessor: (row) => {
          return { id: row.id, status: row.status };
        },
        id: "confirmation",
        Cell: ({ value }) => (
          <div>
            {value?.status == "pending" ? (
              <>
                <span
                  onClick={() => handleReject(value.id)}
                  style={{
                    display: "inline-block",
                    width: "73px",
                    backgroundColor: "black",
                    padding: "3px",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  رد
                </span>
                <span
                  onClick={() =>
                    updateFanCardStatus.mutate({
                      id: value.id,
                      body: { status: "accepted", rejectReason: "" },
                    })
                  }
                  style={{
                    width: "73px",
                    padding: "3px",
                    display: "inline-block",
                    backgroundColor: "green",
                    color: "white",
                    cursor: "pointer",
                    marginLeft: "10px",
                  }}
                >
                  تایید
                </span>
              </>
            ) : (
              "-"
            )}
          </div>
        ),
      },

      {
        Header: "",
        accessor: "actions",
        Cell: ({ value, row }) => {
          return (
            <IconsCell
              profile={row.original}
              refetch={refetch}
              page={queryString.page}
            />
          );
        },
      },
    ],
    [queryString.page]
  );

  columns.reverse();
  // Create an instance of the useTable hook
  //@ts-ignore

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    //@ts-ignore
  } = useTable(
    //@ts-ignore

    { columns, data: data?.fanCards, defaultColumn },
    useFilters,
    useSortBy,
    useExportData
  );

  return (
    <div className={"p-c-30"}>
      <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>دلیل رد درخواست</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="rejectReason">
              <Form.Label>لطفا دلیل رد را وارد کنید:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
            انصراف
          </Button>
          <Button variant="primary" onClick={confirmReject}>
            تایید
          </Button>
        </Modal.Footer>
      </Modal>
      <div style={{ overflow: "auto" }}>
        <table
          {...getTableProps()}
          style={{
            borderCollapse: "collapse",
            columnGap: "20px",
            direction: "ltr",
            minWidth: "100%",
          }}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell.column.id === "id" ? (
                        // Accessing row index here
                        <span className="rowNum">
                          {(queryString.page - 1) * Number(numberInPage) +
                            index +
                            1}
                        </span>
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div
        className={"d-flex gap-4 py-4 my-8"}
        style={{
          borderBottom: "1px  solid #F1F1F4",
          borderTop: " 1px solid #F1F1F4",
        }}
      ></div>
      {/*Pagination start*/}
      <div style={{ marginRight: "auto" }}>
        <CustomPagination
          activePage={queryString.page}
          setQueryString={setQueryString}
          totalRows={data?.totalRows}
          numberInPage={numberInPage}
        />
      </div>
    </div>
  );
};

const HeaderTextIcon = ({ text }: { text: string }) => {
  return (
    <div
      className={"d-flex align-items-center justify-content-center gap-2"}
      style={{ whiteSpace: "nowrap", margin: "0 3px" }}
    >
      <span>{text}</span> <KTIcon iconName={"filter"} className={"fs-5"} />
    </div>
  );
};

const IconsCell = ({ profile, page }: any) => {
  const icons = [
    {
      iconClass: "fc-12 color-yellow-c cursor-pointer",
      iconName: "eye",
      wrapperClass: "bg-light-yellow-c",
    },
  ];
  const navigate = useNavigate();
  const handleActionClick = (icon: any, profile: any) => {
    if (icon.iconName === "eye") {
      navigate(`/management-fan/details?id=${profile?.user?.id}&page=${page}`, {
        state: profile,
      });
    }
  };
  return (
    <>
      <div className={"IconCell"}>
        {icons.map((icon) => (
          <a onClick={(e) => handleActionClick(icon, profile)}>
            <SquireIconWrapper {...icon} />
          </a>
        ))}
      </div>
    </>
  );
};

export default WomenListTable;
